// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"66004864","353":"e1c083e6","453":"670e15c7","674":"c6e06d12","731":"d28b6d99"}[chunkId] + ".chunk.js";
};